import React, { useState, useRef, useEffect } from 'react';

const EditorIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="4"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="12" y2="16"/></svg>
);
const WhiteboardIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="3"/><path d="M8 5V3m8 2V3"/><path d="M3 17l3-3 3 3 3-3 3 3 3-3 3 3"/></svg>
);
const DocIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="3" width="12" height="18" rx="2"/><line x1="9" y1="7" x2="15" y2="7"/><line x1="9" y1="11" x2="15" y2="11"/><line x1="9" y1="15" x2="13" y2="15"/></svg>
);
const WebsiteIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const tabStyle = (active, type) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 12,
  border: 'none',
  background: active ? (type === 'homework' ? 'rgba(238,90,36,0.1)' : 'rgba(233, 233, 237, 0.7)') : 'rgba(255,255,255,0.2)',
  borderRadius: 8,
  padding: '11px 21px',
  color: active ? (type === 'homework' ? '#ee5a24' : '#444') : '#bbb',
  cursor: 'pointer',
  fontWeight: active ? 700 : 400,
  boxShadow: active ? (type === 'homework' ? '0 2px 8px rgba(238,90,36,0.15)' : '0 2px 8px rgba(68,68,68,0.10)') : 'none',
  transition: 'all 0.22s cubic-bezier(.4,0,.2,1)',
  outline: 'none',
});

const iconStyle = {
  fontSize: 19,
  filter: 'drop-shadow(0 1px 2px rgba(68,68,68,0.10))',
  display: 'flex',
  alignItems: 'center',
};

const WhiteboardMenuIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="3"/><rect x="7" y="9" width="4" height="4" rx="1.2"/><path d="M16 9h2m-2 2h2m-2 2h2"/></svg>
);
const DocMenuIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14,2 14,8 20,8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10,9 9,9 8,9"/>
  </svg>
);

const WebsiteMenuIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const HomeworkIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ee5a24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9,22 9,12 15,12 15,22"/>
  </svg>
);

const HomeworkMenuIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ee5a24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9,22 9,12 15,12 15,22"/>
  </svg>
);

const BottomNavigationBar = ({ whiteboards, currentTab, setCurrentTab, addWhiteboard, addDoc, addWebsite, addHomework, onDeleteTab, onReorderTabs, isStudent = false }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [hoveredTab, setHoveredTab] = useState(null);
  const [draggedTab, setDraggedTab] = useState(null);
  const [dragOverTab, setDragOverTab] = useState(null);
  const menuRef = useRef();
  const plusRef = useRef();
  const [menuPos, setMenuPos] = useState({ left: '50%', bottom: 100 });

  // Закрытие меню при клике вне
  useEffect(() => {
    if (!showMenu) return;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) && plusRef.current && !plusRef.current.contains(e.target)) setShowMenu(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showMenu]);

  // Позиционирование меню над плюсом
  useEffect(() => {
    if (showMenu && plusRef.current) {
      const plusRect = plusRef.current.getBoundingClientRect();
      const panelRect = plusRef.current.parentNode.getBoundingClientRect();
      // left относительно панели
      const left = plusRect.left - panelRect.left + plusRect.width / 2;
      setMenuPos({ left, bottom: panelRect.height - (plusRect.top - panelRect.top) + 20 });
    }
  }, [showMenu]);

  // Для анимации закрытия
  // eslint-disable-next-line no-unused-vars
  const [menuVisible, setMenuVisible] = useState(false);
  useEffect(() => {
    if (showMenu) {
      setMenuVisible(true);
    } else {
      const timeout = setTimeout(() => setMenuVisible(false), 180);
      return () => clearTimeout(timeout);
    }
  }, [showMenu]);

  // Drag & Drop handlers
  const handleDragStart = (e, tabIndex) => {
    setDraggedTab(tabIndex);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target.outerHTML);
  };

  const handleDragOver = (e, tabIndex) => {
    e.preventDefault();
    if (draggedTab !== null && draggedTab !== tabIndex) {
      setDragOverTab(tabIndex);
    }
  };

  const handleDragLeave = () => {
    setDragOverTab(null);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedTab !== null && draggedTab !== dropIndex && onReorderTabs) {
      onReorderTabs(draggedTab, dropIndex);
    }
    setDraggedTab(null);
    setDragOverTab(null);
  };

  return (
    <>
      <div data-tour="lesson-tabs" style={{ position: 'fixed', bottom: 'env(safe-area-inset-bottom, 0px)', left: 0, right: 0, zIndex: 900, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
        <div style={{
          background: 'rgba(255,255,255,0.7)',
          backdropFilter: 'blur(16px)',
          borderRadius: 19,
          boxShadow: '0 8px 32px 0 rgba(68,68,68,0.13)',
          display: 'flex',
          alignItems: 'center',
          gap: 21,
          padding: '17px 32px',
          margin: 19, 
          pointerEvents: 'auto',
          transition: 'all 0.22s cubic-bezier(.4,0,.2,1)',
          position: 'relative',
          zIndex: 1000,
        }}>
          {/* Editor tab */}
          <div 
            style={{ position: 'relative' }}
            onMouseEnter={() => setHoveredTab(0)}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <button
              style={tabStyle(currentTab === 0, 'editor')}
              className="mainbar-btn"
              onClick={() => setCurrentTab(0)}
            >
              <span style={iconStyle}>{EditorIcon}</span>
              <span>1</span>
            </button>
          </div>
          {/* Whiteboard/doc tabs */}
          {whiteboards.map((wb, idx) => (
            <div 
              key={wb.id} 
              style={{ 
                position: 'relative',
                opacity: draggedTab === idx + 1 ? 0.5 : 1,
                transform: dragOverTab === idx + 1 ? 'translateX(10px)' : 'translateX(0)',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={() => setHoveredTab(idx + 1)}
              onMouseLeave={() => setHoveredTab(null)}
              draggable={!isStudent}
              onDragStart={!isStudent ? (e) => handleDragStart(e, idx + 1) : undefined}
              onDragOver={!isStudent ? (e) => handleDragOver(e, idx + 1) : undefined}
              onDragLeave={!isStudent ? handleDragLeave : undefined}
              onDrop={!isStudent ? (e) => handleDrop(e, idx + 1) : undefined}
            >
              <button
                style={tabStyle(currentTab === idx + 1, wb.type)}
                className="mainbar-btn"
                onClick={() => setCurrentTab(idx + 1)}
              >
                <span style={{
                  ...iconStyle,
                  filter: wb.type === 'homework' ? 'drop-shadow(0 1px 2px rgba(238,90,36,0.3))' : iconStyle.filter
                }}>
                  {wb.type === 'whiteboard' ? WhiteboardIcon : 
                   wb.type === 'doc' ? DocIcon : 
                   wb.type === 'website' ? WebsiteIcon :
                   wb.type === 'homework' ? HomeworkIcon : DocIcon}
                </span>
                <span>{idx + 2}</span>
              </button>
              {hoveredTab === idx + 1 && !isStudent && onDeleteTab && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteTab(idx + 1);
                  }}
                  style={{
                    position: 'absolute',
                    top: -7,
                    right: -7,
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.9)',
                    border: 'none',
                    color: '#e11d48',
                    fontSize: 12,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                    transition: 'all 0.18s cubic-bezier(.4,0,.2,1)',
                  }}
                >
                  ×
                </button>
              )}
            </div>
          ))}
          {!isStudent && (
            <button
              ref={plusRef}
              data-tour="lesson-add-tab"
              style={{
                fontSize: 20, 
                border: 'none', 
                background: 'rgba(243,243,243,0.85)', 
                borderRadius: 11, 
                width: 36, 
                height: 36, 
                cursor: 'pointer', 
                color: '#444', 
                marginLeft: 8,
                boxShadow: '0 2px 8px rgba(68,68,68,0.10)',
                transition: 'all 0.22s cubic-bezier(.4,0,.2,1)',
                outline: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                zIndex: 900,
              }} 
              className="mainbar-btn"
              onClick={() => setShowMenu(v => !v)}
            >
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
          )}
          {showMenu && !isStudent && (
            <div
              ref={menuRef}
              style={{ 
                position: 'absolute', 
                left: menuPos.left,
                transform: 'translateX(-50%)',
                bottom: menuPos.bottom,
                background: '#fff',
                borderRadius: 12, 
                boxShadow: '0 8px 32px 0 rgba(68,68,68,0.13)', 
                padding: 0, 
                display: 'flex', 
                flexDirection: 'column', 
                minWidth: 120,
                zIndex: 901,
                animation: showMenu ? 'fadeScaleIn 0.18s cubic-bezier(.4,0,.2,1)' : 'fadeScaleOut 0.18s cubic-bezier(.4,0,.2,1)',
                pointerEvents: showMenu ? 'auto' : 'none',
                opacity: showMenu ? 1 : 0,
              }}
            >
              {/* стрелочка */}
              <div style={{
                position: 'absolute',
                left: '50%',
                bottom: -9,
                transform: 'translateX(-50%)',
                width: 19,
                height: 9,
                overflow: 'visible',
                zIndex: 902,
                pointerEvents: 'none',
              }}>
                <svg width="19" height="9" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 14L2 0H26L14 14Z" fill="#fff"/>
                </svg>
              </div>
              <button 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 8, 
                  fontSize: 11, 
                  border: 'none', 
                  background: 'transparent',
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12,
                  borderBottom: '1px solid #ececec',
                  padding: '12px 16px 9px 13px',
                  color: '#444', 
                  cursor: 'pointer', 
                  fontWeight: 700,
                  transition: 'all 0.13s cubic-bezier(.4,0,.2,1)',
                  outline: 'none',
                  transform: 'scale(1)',
                }} 
                className="menu-popup-btn"
                onClick={() => { addWhiteboard(); setShowMenu(false); }}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>{WhiteboardMenuIcon}</span> Whiteboard
              </button>
              <button 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 8, 
                  fontSize: 11, 
                  border: 'none', 
                  background: 'transparent',
                  borderBottom: '1px solid #ececec',
                  padding: '9px 16px 9px 13px',
                  color: '#444', 
                  cursor: 'pointer', 
                  fontWeight: 700,
                  transition: 'all 0.13s cubic-bezier(.4,0,.2,1)',
                  outline: 'none',
                  transform: 'scale(1)',
                }} 
                className="menu-popup-btn"
                onClick={() => { addDoc(); setShowMenu(false); }}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>{DocMenuIcon}</span> Doc
              </button>
              <button 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 8, 
                  fontSize: 11, 
                  border: 'none', 
                  background: 'transparent',
                  borderBottom: '1px solid #ececec',
                  padding: '9px 16px 9px 13px',
                  color: '#444', 
                  cursor: 'pointer', 
                  fontWeight: 700,
                  transition: 'all 0.13s cubic-bezier(.4,0,.2,1)',
                  outline: 'none',
                  transform: 'scale(1)',
                }} 
                className="menu-popup-btn"
                onClick={() => { addWebsite(); setShowMenu(false); }}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>{WebsiteMenuIcon}</span> Website
              </button>
              <button 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 8, 
                  fontSize: 11, 
                  border: 'none', 
                  background: 'transparent',
                  borderBottomLeftRadius: 12,
                  borderBottomRightRadius: 12,
                  padding: '9px 16px 12px 13px',
                  color: '#444', 
                  cursor: 'pointer', 
                  fontWeight: 700,
                  transition: 'all 0.13s cubic-bezier(.4,0,.2,1)',
                  outline: 'none',
                  transform: 'scale(1)',
                }} 
                className="menu-popup-btn"
                title="Add homework"
                onClick={() => { addHomework(); setShowMenu(false); }}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>{HomeworkMenuIcon}</span> Homework
              </button>
            </div>
          )}
        </div>
      </div>
      <div style={{ marginBottom: 93 }} />
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translate(-50%, 10px); }
            to { opacity: 1; transform: translate(-50%, 0); }
          }
          @keyframes fadeScaleIn {
            from { opacity: 0; transform: translateX(-50%) scale(0.92); }
            to { opacity: 1; transform: translateX(-50%) scale(1); }
          }
          @keyframes fadeScaleOut {
            from { opacity: 1; transform: translateX(-50%) scale(1); }
            to { opacity: 0; transform: translateX(-50%) scale(0.92); }
          }
          .menu-popup-btn:hover {
            background: #f5f5f7 !important;
            transform: scale(1.03);
          }
          .mainbar-btn:hover {
            background: #f5f5f7 !important;
            transform: scale(1.03);
          }
        `}
      </style>
    </>
  );
};

export default BottomNavigationBar; 